Vue.component('event', {
	props: [],
	methods: {
	}
});;new Vue({
	el: '#program',
	delimiters: ['@{', '}'],
	data: {
		page: 1,
		per_page: 100,
		category: '',
		events: [],
		auto: false,
		active: false,
		end: false,
		button_position: 0,
        current_month: null,
	},
	mounted() {
		this.updateData();
        this.applyStickerLogic();
	},
	updated() {
        this.updatePosition();
        this.applyStickerLogic();
	},
	created() {
		if (window.location.hash) {
			this.category = window.location.hash.substring(1);
		}
		window.addEventListener('scroll', this.handleScroll);
	},
	methods: {
        addQueryParam: function(uri, key, value) {
            if (!uri.includes('?')) {
              // If there are no query parameters yet, add the first one.
              return `${uri}?${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            } else {
              // If there are already query parameters, append the new one.
              return `${uri}&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            }
        },
		updateData: function(more = false) {

            var self = this,
                baseUrl = window.location.origin,
                uri = baseUrl + '/wp-json/wp/v2/event';

			// add page number to uri
			uri = this.addQueryParam(uri, 'page', this.page);

			// add posts per page to uri
			uri = this.addQueryParam(uri, 'per_page', this.per_page);

			// add order by date ASC
			uri = this.addQueryParam(uri, 'filter[orderby]', 'event_date');
			uri = this.addQueryParam(uri, 'order', 'asc');

			if (this.category) {
				uri = this.addQueryParam(uri, 'filter[taxonomy]', 'category');
				uri = this.addQueryParam(uri, 'filter[term]', this.category);
			}

			axios.get(uri.toString())
				.then(function(response){
					var events = more ? (self.events).concat(response.data) : response.data;

					// Set a startIndex for checking dividers, so only the new values will be checked for a divider
					var startIndex = more ? self.events.length-1 : 0

					self.events = self.addDividersToEvents(events,startIndex);

					// Update pages
					self.page = self.page + 1;

					// Check if we got all the events
					self.end = (response.data).length<self.per_page;

					// Disable active state
					self.active = false;

					// Update button position
					self.updatePosition();
				})
				.catch(function(error) {
					self.end = true;
					self.active = false;
					self.updatePosition();
				});

		},
		addDividersToEvents: function(events,fromIndex) {
			if (!events.length) 
				return events

            var currentMonth = new Date().toLocaleString('default', { month: 'long' }).toLowerCase();

			for(var i= fromIndex; i<events.length; i++) {
				if (events[i].event.start_date === undefined)
					continue; 

                if (events[i].event.start_date === currentMonth.toLowerCase()) {
                    continue;
                } 

				// Check if current event is in a different month
				if (this.current_month != events[i].event.start_date) {
					// Set new current_month
					this.current_month = events[i].event.start_date;
					// Insert divider into the events
					events.splice(i, 0, { divider: true, name: this.current_month });
				}
			}
			return events;
		},
		updatePosition: function() {
			var button = document.getElementById('load-more');

			if (!button) return;
			
			this.button_position = button.getBoundingClientRect().top;
		},
		handleScroll: function() {
			if (this.active || this.end) return;

			var height = window.innerHeight + (window.scrollY * 2),
				self = this;

			if (height > this.button_position) {

				this.active = true;

				setTimeout(function(){
					self.updateData(true);
				}, 500);
			}
  		},
		setCategory: function(event) {
			var data = event.target.dataset;
			
			// Clear settings
			this.page = 1;
			this.end = false;
			this.current_month = null;

			// Set new category
			this.category = data.slug;

			// Update program grid
			this.updateData();
		},
		isActiveCategory: function(category) {
			return this.category === category;
		},
        applyStickerLogic() {
            // Get all highlighted program-items
            var programItems = document.querySelectorAll('.program-item--highlight');

            programItems.forEach(function(item) {
                // Get all desktop versions of the details container
                var desktopContainer = item.querySelector('.program-item__column--desktop');

                if (desktopContainer) {
                    var sticker = desktopContainer.querySelector('.program-item__sticker');
                }
        
                // If sticker is available, get its width
                if (sticker) {
                    var width = sticker.offsetWidth;

                    // Set transforms on stickers
                    if (window.innerWidth >= 768 && window.innerWidth < 1024) {
                        sticker.style.transform = `translate3d(-0px, 0, 0)`;
    
                        item.addEventListener('mouseover', function() {
                            sticker.style.transform = `translate3d(${0}px, 0, 0)`;
                        });
                        item.addEventListener('mouseout', function() {
                            sticker.style.transform = `translate3d(0, 0, 0)`;
                        });
                    } else {
                        sticker.style.transform = `translate3d(-${width - 60}px, 0, 0)`;
    
                        item.addEventListener('mouseover', function() {
                            sticker.style.transform = `translate3d(0, 0, 0)`;
                        });
                        item.addEventListener('mouseout', function() {
                            sticker.style.transform = `translate3d(-${width - 60}px, 0, 0)`;
                        });
                    }
                }
            });
        }
	}
});
